import { createSelector } from 'reselect';
export const selectAnswers = createSelector((state) => state.answers.list, answers => answers);
export const selectAnswersAsSimpleArray = createSelector(selectAnswers, answers => answers.map((answer) => answer));
